export const byCompanyPortfolioChart = {
    title: 'Technology Portfolio (Comparison by Company)',
    description: `This displays technology groups (clusters) to which each selected company's patent applications belong. The location of each cluster represents the overall trend of the theme, thus the same as the "Cluster and Value Chain". On the othe hand, the size of the bubble represents the score or value specific to each selected company.`,
    copy: 'Copy',
    download: 'Download',
    setting: 'Configuration',
    labelFixedMsg: 'Please turn off "Label Fix" when you want to select a cluster',

    // csvのヘッダー
    column1: 'Cluster ID',
    column2: 'Cluster Name',
    column3: 'Domain',
    column4: 'Score (Cluster)',
    column5: 'Market Expectation',
    column6: 'Company Name',
    column7: 'Registered Country',
    column8: 'Score (Company)',
    column9: 'Number of Patent Applications',
    column10: 'Number of Material Patents',
    column11: 'Material Patent rate',
    column12: 'Number of Forward Citations (Average)'
}
